import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'

export const SplitEmailRedirect = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  const isMobile = useMobileMediaQuery()
  const basePath = isMobile
    ? '/settings-preferences'
    : '/account/settings-preferences'

  useEffect(() => {
    if (token) {
      navigate(`${basePath}?split=${token}`, {
        replace: true
      })
    }
  }, [token])

  return null
}
